<template>
  <div class="floating-button">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style scoped>
.floating-button {
  position: fixed;
  bottom: 5px;
  left: 107px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9;
}
</style>
